import MobileHeader from './mobileHeader'
import StickyHeader from './StickyHeader'

const $ = jQuery.noConflict()

class AlertBar {
    constructor() {
        this.alertBar = '.main-header__alert'
        this.alertBarClose = '.main-header__alert-close'
        this.header = '.main-header';
        this.inpageNav = '.sidebar-header';
    }

    init() {
        this.showAlertBar()
        this.closeAlertBar()
    }

    showAlertBar() {
        const closeDate = localStorage.getItem('alertbar-close-date')

        if (closeDate) {
            const date = new Date(parseInt(closeDate))
            const actualDate = new Date()
            const diff = actualDate - date
            const hoursDiff = Math.floor((diff / (1000 * 60 * 60)) % 24)

            if (hoursDiff >= 24) {
                localStorage.removeItem('alertbar-close-date')
                $(this.alertBar).addClass('main-header__alert--visible')
            }
        } else {
            $(this.alertBar).addClass('main-header__alert--visible')
        }

        this.resized();
    }

    closeAlertBar() {
        $(this.alertBarClose).on('click', () => {
            $(this.alertBar).remove()
            const date = new Date()
            localStorage.setItem('alertbar-close-date', date.getTime())
            this.resized();
            this.inpageNavPosition();
        })
    }

    resized() {
        MobileHeader.resized();
        StickyHeader.resize();
    }

    inpageNavPosition() {
        $(this.inpageNav).css({ 'top': $(this.header).outerHeight() });
    }
}

export default new AlertBar()
